import { LanguageContext } from '@nzyme/i18n/LanguageContext.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { computed } from 'vue';
import { parseLocale } from '@sigma/common/i18n/Locale.js';
import { BrowserLocaleContext } from './BrowserLocaleContext.js';
/**
 * Browser language context.
 * Derives language from the current locale.
 */
export const BrowserLanguageContext = defineService({
    name: 'BrowserLanguageContext',
    implements: LanguageContext,
    deps: {
        localeCtx: BrowserLocaleContext,
    },
    setup({ localeCtx }) {
        const language = computed(() => {
            const parsed = parseLocale(localeCtx.locale.value);
            return parsed?.language ?? 'en';
        });
        return () => language.value;
    },
});
//# sourceMappingURL=BrowserLanguageContext.js.map